export default [{
    path: '/original_wise',
    component: resolve => require(['../../../view/find/original/original.vue'], resolve),
},
{
    path: '/activity',
    component: resolve => require(['../../../view/find/original/activity.vue'], resolve),
},
]


// WEBPACK FOOTER //
// ./src/router/find/original/index.js